import React, { useEffect, useState } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { FaMinus } from "react-icons/fa";

const ClinicPatientTagForm = ({ tag, isNumber, isValue }) => {
  const [updatedTagLabel, setUpdatedTagLabel] = useState(tag.label);
  const [isHide, setIsHide] = useState(tag.isHide);

  const deleteTag = () => {
    if (window.confirm("You will delete this tag. Are you sure?")) {
      setIsHide(true);
    }
  };

  useEffect(() => {
    tag.label = updatedTagLabel;
    tag.isHide = isHide;
  }, [updatedTagLabel, isHide]);
  return (
    <>
      {!isHide && (
        <Row>
          <Form.Group
            // controlId="visitTagLabel"
            className="col-10"
          >
            <Form.Control
              type="name"
              placeholder="type history items like: HTN"
              value={updatedTagLabel}
              onChange={(e) => setUpdatedTagLabel(e.target.value)}
              isValid={updatedTagLabel}
            ></Form.Control>
          </Form.Group>

          <Form.Group className="col-2 align-self-end text-center">
            <Button className="btn btn-danger" onClick={() => deleteTag(tag)}>
              <FaMinus />
            </Button>
          </Form.Group>
        </Row>
      )}
    </>
  );
};

export default ClinicPatientTagForm;
